import Vue from 'vue'
import axios from 'axios';
import {router,routerGo} from '../router';
import Qs from 'qs'
import { Message } from 'element-ui';

//let base = "http://192.168.30.201:8401/"; //欧阳磊
//  let base = "http://58.49.75.58:8010/"; //欧阳磊
// let base = "http://192.168.20.51:8010/"; //本地李斌
 let base = "http://47.114.77.95:8010/"; // 线上-李斌
//let base = "http://192.168.1.114:8010/"; //美术馆自己的内网
//let base_guest = "http://192.168.30.205:8901/#/home";
//let base_admin = "http://192.168.30.205:8900/#/CollectionDisplay";

let base_guest = "http://wham.gcmc2018.com:8888/#/details";    //前台游客端
let base_admin = "http://wham.admin.gcmc2018.com:8888/#/";   //后台管理端
//let base_guest = "http://192.168.1.114:8010/guest/index.html#/details";    //前台游客端
//let base_admin = "http://192.168.1.114:8010/admin/index.html#/";   //后台管理端

//let base_guest = "http://192.168.30.205:8901/#/details";    //前台游客端
//let base_admin = "http://192.168.30.205:8900/#/";   //后台管理端
let base_mobile = "http://wham.mobile.gcmc2018.com:8888";    //手机端

let instance = axios.create({
        baseURL: base,
        timeout: 10000,
        transformRequest: [function(data) {
            var token = data.hasOwnProperty("artToken");
            if (!token) {
                data.token = localStorage.getItem("artToken") ? localStorage.getItem("artToken") : ''
            }
            data = Qs.stringify(data);
            return data
        }]
    })
    //axios的一些配置，比如发送请求显示loading，请求回来loading消失之类的
    //todo 拦截器
instance.interceptors.request.use(function(config) { //配置发送请求的信息
    // Loading.service();
    /* if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
       config.headers.Authorization = `token ${store.state.token}`;
     }*/

    return config;
}, function(error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(
    response => {
        /* let loadingInstance = Loading.service();
         loadingInstance.close();*/

        return response;
    },
    error => {
        if (error.response) {
            console.log(error.response);
            switch (error.response.status) {
                case 401:
                    // 返回 401 清除token信息并跳转到登录页面

                    localStorage.removeItem("token")
                    localStorage.removeItem("user")
                        // router.replace({
                        //   path: '/login',
                        //   query: {redirect: router.currentRoute.fullPath}
                        // })
                    routerGo('login');
                    break;
                case 404:
                    break;
            }
        }
        return Promise.reject(error.response.data) // 返回接口返回的错误信息
    });



function apiAxios(method, url, params, success, failure) {

    return instance({
            method: method,
            url: getUrl(method, url),
            data: method === 'POST' || method === 'PUT' ? params : {},
            params: method === 'GET' || method === 'DELETE' ? params : null,
            headers: method == 'GET' ? {
                'Content-Type': 'application/x-www-form-urlencoded' /*application/json*/
            } : {

            }
        })
        .then(function(res) {
            if (res.data.result == 204) {
                // alert('登录失效，请重新登录')
                localStorage.clear();
                routerGo('login');
                return false
            }
            if (res.data.result == 201) {
                Message.error(res.data.message);
                return false
            } else if (res.data.result == 500) {
                Message.error("服务器开小差了");
            } else {
                return res.data
            }
        }, function(res) {
            Message.error('访问异常，请重试');
            console.log(res)
        })
}

function getUrl(method, url) {
    let token = localStorage.getItem("artToken");
    if (method === 'GET') {
        if (url.indexOf('?') > -1) {
            return url + '&token=' + token;
        } else {
            return url + '?token=' + token;
        }
    } else {
        return url;
    }
}

// 返回在vue模板中的调用接口
export default {
    get: function(url, params, success, failure) {
        return apiAxios('GET', url, params, success, failure)
    },
    post: function(url, params, success, failure) {
        return apiAxios('POST', url, params, success, failure)
    },
    put: function(url, params, success, failure) {
        return apiAxios('PUT', url, params, success, failure)
    },
    delete: function(url, params, success, failure) {
        return apiAxios('DELETE', url, params, success, failure)
    },
    baseURL: base,
    base_admin: base_admin,
    base_guest: base_guest,
    base_mobile:base_mobile,
}



// WEBPACK FOOTER //
// ./src/fetch/api.js